import $ from 'jquery';
import { debounce } from 'lodash';

import { subscribeOn } from '~/state/bridge';
import TargetingClient from '~/state/Targeting/client';
import AgentsClient from '~/state/Agents/client';
import CampaignClient from '~/state/Campaign/client';

import { render, querySubscription } from '~/theseus';
import AgentLanding from '~/theseus/components/AgentLanding';
import Navbar from '~/theseus/components/Navbar';
import AdPreview from '~/theseus/components/AdPreview';

import { renderCreative } from './shared/creatives';

import displayOffice from './components/prop-display-office';
import { generatePreview, validateAtLeastTwoImages } from './components/ad-preview';
import getCreatives from './components/getCreatives';

import analyzeLink from './shared/analyze';
import { lb } from './shared/lightbox';
import { init } from './shared/login';

import {
  publishControls,
  override_lookup,
  add_tag,
  post_ad,
  checkLinkType,
} from './components/common';

import {
  addSmallWarning, getSmallImages, isSmall, isInstagramAd,
} from './lib/instagram';

const LINK_TYPE = 'property';

let account_id = null;
let page_id = null;

querySubscription('account_id', (id) => { account_id = id; });
querySubscription('page_id', (id) => { page_id = id; });

let link = null;
let repost = null;
let $sub = null;
let i_sub = null;
let landing = true;
let ranAnalyze = false;
let past_templates = 'none';
let images = [];
let subs = [];
let sel = [];
let gallery_divs = [];
let past_main_creatives = [];
let past_sub_creatives = [];
let field_divs = {};
let key_values = {};
const property_keys = [];
let $active;

const sub_creative_markup = `
  <div class='creative-item' style='display: -webkit-box; display: -webkit-flex; display: -ms-flexbox; display: flex;'>
    <div class='creative-item__thumbnail'>
      <img />
    </div>
    <form action='' class='creative-item__edit-creatives'>
      <div class='creative-item__row'>
        <input class='creative-item__first-sub can-add-tags' type='text' placeholder='First Line'>
        <p class='creative-item__first-preview'></p>
      </div>
      <div class='creative-item__row'>
        <input class='creative-item__second-sub can-add-tags' type='text' placeholder='Second Line'>
        <p class='creative-item__second-preview'></p>
      </div>
    </form>
    <div class='creative-item__options'>
      <button class='creative-item__clear-creative'>Clear Lines</button>
      <button class='creative-item__remove-item'>Remove From Ad</button>
    </div>
  </div>
`;

wire_keyup($('.main-creative__field'), $('.main-creative__preview'), -1, -1);

function fill_main_creative() {
  if (past_templates == 'main') {
    return;
  }
  past_templates = 'main';
  $('.past-templates__container').hide();
  $('.past-templates__container').empty();
  past_main_creatives.forEach((e) => {
    const tmp = e;
    const $item = $(`<div class='past-templates__item'>${tmp.markedup}</div>`);
    $('.past-templates__container').append($item);
    $('.past-templates__container').slideDown('fast');
    $item.on('click', () => {
      $('.main-creative__field').val(tmp.template);
      $('.main-creative__field').focus();
      $('.main-creative__field').trigger('keyup');
    });
  });
}

function wire_keyup($i, $p, i, j) {
  $i.on('keyup', debounce(() => {
    const v = $i.val();
    if (i >= 0 && j >= 0) {
      images[i].lines[j] = v;
    }

    renderCreative({
      creative_text: v, key_values, lookup: {}, override_lookup,
    })
      .then(res => $p.html(res.markedup))
      .catch(err => console.error('property - render error: ', err));
  }, 20));

  const input = $i.get(0);
  let p = null;
  $p.on('mouseenter', 'span', function () {
    p = input.selectionStart;
    $i.addClass('field--preview');
    if ($(this).hasClass('not-found')) $i.addClass('field--preview-not-found');
    input.focus();
    input.setSelectionRange($(this).attr('data-start'), $(this).attr('data-stop'));
    if ($(this).attr('data-field') in field_divs) {
      field_divs[$(this).attr('data-field')].addClass('available-fields__item--preview');
    }
  });
  $p.on('mouseleave', 'span', function () {
    $i.removeClass('field--preview field--preview-not-found');
    if ($(this).attr('data-field') in field_divs) {
      field_divs[$(this).attr('data-field')].removeClass('available-fields__item--preview');
    }
    if (p != null) {
      input.setSelectionRange(p, p);
    }
  });
  $p.on('click', 'span', function (e) {
    const v = $i.val();
    const start = parseInt($(this).attr('data-start'), 10);
    const stop = parseInt($(this).attr('data-stop'), 10);
    let replacement = $(e.target).text();
    if ($(this).hasClass('not-found')) replacement = '';
    $i.removeClass('field--preview field--preview-not-found');
    if ($(this).attr('data-field') in field_divs) {
      field_divs[$(this).attr('data-field')].removeClass('available-fields__item--preview');
    }
    $i.val(v.substring(0, start) + replacement + v.substring(stop));
    const new_p = start + replacement.length;
    $i.focus();
    $i.trigger('keyup');
    input.setSelectionRange(new_p, new_p);
  });
}

let display_max_prompt = null;
function update_selected_image() {
  clearTimeout(display_max_prompt);
  if (sel.length == 0) {
    $('.image-picker__image-amount').text(`${images.length} Images Loaded`).removeClass('image-picker__image-amount--img-selected');
    $('.clear-order').removeClass('clear-order--show');
    $('.image-picker__image-amount').removeClass('image-picker__image-amount--max-reached');
    $('.image-picker__header').removeClass('image-picker__header--max-reached');
  } else if (sel.length >= 10) {
    $('.image-picker__image-amount').text(`${sel.length} Images Loaded`);
    $('.image-picker__image-amount').addClass('image-picker__image-amount--max-reached');
    $('.image-picker__header').addClass('image-picker__header--max-reached');
    display_max_prompt = setTimeout(() => {
      $('.image-picker__header').removeClass('image-picker__header--max-reached');
    }, 3000);
  } else {
    $('.image-picker__image-amount').text(`${sel.length} Images Selected`).addClass('image-picker__image-amount--img-selected');
    $('.image-picker__image-amount').removeClass('image-picker__image-amount--max-reached');
    $('.image-picker__header').removeClass('image-picker__header--max-reached');
    $('.clear-order').addClass('clear-order--show');
  }
}

$('.clear-order').on('click', () => {
  sel.forEach((k) => {
    gallery_divs[k].removeClass('image-picker__item--added');
    gallery_divs[k].removeAttr('orderval');
  });
  sel = [];
  update_selected_image();
  $('.image-picker__creatives-container').empty();
});

$('.link__container').on('submit', () => {
  $('.link__add-link').addClass('link__add-link--loading');
  $('.link__input').addClass('link__input--loading');
  link = $.trim($('.link__input').val());
  if (ranAnalyze) {
    alert('The page will refresh to load the new property.');
    window.onbeforeunload = null;
    window.location.search = `?link=${encodeURIComponent(link)}`;
  }

  analyzeLink(
    'analyze_link',
    LINK_TYPE,
    { link, cumulative_criteria: {} },
    repost?.lead_ad_enabled,
  )
    .then((r) => {
      checkLinkType(link, 'property', r.analyze_type);
      ranAnalyze = true;
      $sub = null;
      past_templates = 'none';
      sel = [];
      gallery_divs = [];
      past_main_creatives = [];
      past_sub_creatives = [];
      images = [];
      /* eslint-disable */
      link = r.link;
      key_values = r.properties[0];
      /* eslint-enable */
      field_divs = {};
      subs = [];
      TargetingClient.setAsReady();
      $('.main-creative').removeClass('main-creative--disabled');
      $('.image-picker').removeClass('image-picker--disabled');
      $('.button-group').removeClass('button-group--disabled');
      $('.campaign').removeClass('campaign--hidden');
      $active = $('.main-creative__field');
      r.property_keys.forEach((key) => {
        const $item = $("<li class='available-fields__item'></li>").html(key);
        property_keys.push(key);
        field_divs[key] = $item;
        $('.available-fields__container').append($item);
        $item.on('mouseenter', () => {
          $('.available-fields__display-value').html(key_values[key]);
        });
        $item.on('click', () => {
          add_tag(key, null, $active);
        });
      });
      r.properties[0].images.forEach((url) => {
        images.push({ url, lines: ['', ''] });
      });
      images.forEach((image, i) => {
        subs.push('');
        const $item = $(`<div class='image-picker__item'><img src='${image.url}'></div></div>`);
        $('.image-picker__gallery').append($item);
        gallery_divs.push($item);
        $item.on('click', (e) => {
          const target = $(e.target).parent('.image-picker__item')[0];
          if (target) {
            $(target)
              .removeAttr('orderval')
              .toggleClass('image-picker__item--added');
          } else {
            $(e.target)
              .removeAttr('orderval')
              .toggleClass('image-picker__item--added');
          }
          if (sel.indexOf(i) == -1) {
            sel.push(i);
          } else {
            sel.splice(sel.indexOf(i), 1);
          }
          sel.forEach((k, j) => {
            gallery_divs[k].attr('orderval', j + 1);
          });
          if (sel.indexOf(i) != -1) {
            create_image_creative(i);
          } else {
            $(`.creative-item[creativeorder=${i}]`).slideUp('fast', () => {
              $(`.creative-item[creativeorder=${i}]`).remove();
            });
          }
          update_selected_image();
          return false;
        });
      });
      update_selected_image();
      $('.prop-data__address').html(r.properties[0].address).on('click', () => { add_tag('address', null, $active); });
      $('.prop-data__beds').html(r.properties[0].beds).on('click', () => { add_tag(null, '[beds|bedroom]', $active); });
      $('.prop-data__baths').html(r.properties[0].baths).on('click', () => { add_tag(null, '[baths|bath]', $active); });
      $('.prop-data__sqft').html(r.properties[0].living_area).on('click', () => { add_tag(null, '[living_area] sq. ft.', $active); });
      $('.prop-data__price').html(r.properties[0].list_price).on('click', () => { add_tag('list_price', null, $active); });
      if (landing) {
        $('.prop-data__short-url').html(r.properties[0].short_link_landing).on('click', () => { add_tag('short_link_landing', null, $active); });
      } else {
        $('.prop-data__short-url').html(r.properties[0].short_link).on('click', () => { add_tag('short_link', null, $active); });
      }
      $('.main-creative__descr').html(r.properties[0].remarks);
      CampaignClient.ad.changeName(r.name);
      $('.main-creative__add-prop-data').on('click', () => {
        add_tag(null,
          `Address: ${r.properties[0].address
          }, Beds: ${r.properties[0].beds
          }, Baths: ${r.properties[0].baths
          }, Sq Ft: ${r.properties[0].living_area
          }, Price: ${r.properties[0].list_price}`,
          $active);
      });
      $('.main-creative__add-descr').on('click', () => {
        add_tag(null, r.properties[0].remarks, $active);
      });
      if (repost) {
        $('.main-creative__field').val(repost.main_creative).keyup();
        repost.image_indexes.forEach((v, i) => {
          /* eslint-disable */
          images[v].lines[0] = repost.image_creatives[i].split('///')[0];
          images[v].lines[1] = repost.image_creatives[i].split('///')[1];
          /* eslint-enable */
          gallery_divs[v].trigger('click');
          $('.creative-item__first-sub').keyup();
          $('.creative-item__second-sub').keyup();
        });
      }
      $('.main-creative__field').focus();
      displayOffice($('.image-picker__gallery'), images);
      return Promise.all([
        getCreatives({
          type: 'main',
          keys: r.property_keys,
          key_values,
          override_lookup,
        }),
        getCreatives({
          type: 'image',
          keys: r.property_keys,
          key_values,
          override_lookup,
        }),
      ]);
    })
    .then(([main_creatives, sub_creatives]) => {
      past_main_creatives = main_creatives;
      past_templates = 'none';
      fill_main_creative();

      past_sub_creatives = sub_creatives;
    })
    .catch((err) => {
      console.error('property.js error: ', err);
    });

  return false;
});

$('.image-picker__gallery-toggle').on('click', function () {
  $(this).toggleClass('image-picker__gallery-toggle--switch');
  $('.image-picker__gallery').addClass('image-picker__gallery--wink');
  $('.image-picker__gallery--wink').on('transitionend webkitTransitionEnd', () => {
    $('.image-picker__gallery').toggleClass('image-picker__gallery--2col')
      .off('transitionend webkitTransitionEnd').toggleClass('image-picker__gallery--wink');
  });
});

$('.main-creative__field').on('focus', fill_main_creative);

function create_image_creative(i) {
  const $dom = $(sub_creative_markup);
  images[i].dom = $dom;
  images[i].i = i;
  $dom.attr('creativeorder', i);

  const img = $dom.find('img');
  $(img).attr('src', images[i].url);

  if (isSmall(img[0])) {
    addSmallWarning(img);
  }

  $('.image-picker__creatives-container').append($dom);
  wire_keyup($dom.find('.creative-item__second-sub'), $dom.find('.creative-item__second-preview'), i, 1);
  wire_keyup($dom.find('.creative-item__first-sub'), $dom.find('.creative-item__first-preview'), i, 0);
  $dom.find($('.creative-item__first-sub'))
    .val(images[i].lines[0])
    .trigger('keyup');
  $dom.find($('.creative-item__second-sub'))
    .val(images[i].lines[1])
    .trigger('keyup');
  $dom.find('input.can-add-tags').on('focus', () => {
    $sub = $dom;
    i_sub = i;
    if (past_templates == 'sub') {
      return;
    }
    past_templates = 'sub';
    $('.past-templates__container').hide();
    $('.past-templates__container').empty();
    past_sub_creatives.forEach((v) => {
      const markedup = v.markedup.split('///');
      const template = v.template.split('///');
      const $item = $(`<div class='past-templates__item'><div class='past-templates__row'>${markedup[0]}</div><div class='past-templates__row'>${markedup[1]}</div></div>`);
      $('.past-templates__container').append($item);
      $('.past-templates__container').slideDown('fast');
      $item.on('click', () => {
        if ($sub) {
          /* eslint-disable */
          images[i_sub].lines[0] = template[0];
          $sub.find('.creative-item__first-sub').val(template[0]);
          if (!images[i_sub].displayListingOffice) {
            images[i_sub].lines[1] = template[1];
            $sub.find('.creative-item__second-sub').val(template[1]);
          }
          /* eslint-enable */
          $sub.find('.creative-item__first-sub').focus();
          $sub.find('.creative-item__first-sub').trigger('keyup');
          $sub.find('.creative-item__second-sub').trigger('keyup');
        }
      });
    });
  });
  $dom.find('.creative-item__remove-item').on('click', () => {
    sel.forEach((k) => {
      gallery_divs[k].removeAttr('orderval');
      gallery_divs[k].removeClass('image-picker__item--added');
    });
    sel.splice(sel.indexOf(i), 1);
    sel.forEach((k, j) => {
      gallery_divs[k].attr('orderval', j + 1);
      gallery_divs[k].addClass('image-picker__item--added');
    });
    $dom.slideUp('fast', () => {
      $dom.remove();
    });
    update_selected_image();
    return false;
  });
  $dom.hide().slideDown('fast');
  $dom.find('.creative-item__clear-creative').on('click', () => {
    images[i].lines[0] = '';
    images[i].lines[1] = '';
    $dom.find('.creative-item__first-sub').val('').keyup();
    $dom.find('.creative-item__second-sub').val('').keyup();
  });
}

function post_specific_ad() {
  const newSubs = [];
  sel.forEach((v) => {
    newSubs.push({ i: v, template: `${images[v].lines[0]}///${images[v].lines[1]}` });
  });
  const more_data = {
    image_sub_creatives: JSON.stringify(newSubs),
    landing,
    link,
    main_creative: $('.main-creative__field').val(),
  };

  if (sel.length <= 1) {
    alert('Please add at least 2 images to your post before creating a carousel');
    return false;
  }

  const smallImages = getSmallImages('variable').all;
  if (smallImages.length !== 0 && isInstagramAd()) {
    lb('Some of your images are too small to post on Instagram. Please try a single or multi-link ad with your own images (at least 500px by 500px), or don\'t run this ad on Instagram.', 'fail', null, null, false, false);
    return false;
  }

  post_ad('property', 'property', more_data, null, account_id, page_id);
  return false;
}

function set_landing_page(v) {
  if (v) {
    $('#check-view').attr('checked', true);
    if (key_values.short_link_landing) {
      $('.prop-data__short-url')
        .off('click')
        .html(key_values.short_link_landing)
        .on('click', () => { add_tag('short_link_landing', null, $active); });
    }
  } else {
    $('#check-view').attr('checked', false);
    if (key_values.short_link) {
      $('.prop-data__short-url')
        .off('click')
        .html(key_values.short_link)
        .on('click', () => { add_tag('short_link', null, $active); });
    }
  }
  landing = v;
}

set_landing_page(true);

$('#check-view').on('change', () => {
  if ($('#check-view').is(':checked')) {
    set_landing_page(true);
  } else {
    set_landing_page(false);
  }
});

$(document).on('keyup', (e) => {
  if (e.keyCode == 27) {
    $('.large-image').remove();
  }
});

$('body').on('focus', '.can-add-tags', (e) => {
  $active = $(e.target);
});

function generateSubs() {
  const psubs = {
    creatives: [],
    ad_campaign_cta: $('#campaign-cta').val(),
  };
  sel.forEach((v) => {
    let l1 = images[v].lines[0];
    let l2 = images[v].lines[1];
    if (l1.length === 0) l1 = '';
    if (l2.length === 0) l2 = '';
    psubs.creatives.push({
      i: v,
      template: `${l1}///${l2}`,
    });
  });

  return psubs;
}

function createPreview(type) {
  const newSubs = generateSubs();
  return generatePreview(
    page_id,
    account_id,
    link,
    $('.main-creative__field').val(),
    newSubs,
    override_lookup,
    $('#check-end-card').prop('checked'),
    type,
  );
}

function load_data() {
  render('#agent-landing', <AgentLanding />);
  render('#ad-preview', <AdPreview getPreview={createPreview} validation={validateAtLeastTwoImages(() => generateSubs())} />);
  publishControls('#publish_container', post_specific_ad, LINK_TYPE);
}

function on_repost(post) {
  repost = post;
  $('.link__input').val(repost.link);
  $('.link__container').trigger('submit');
}

init(on_repost)
  .then(load_data);
